var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisblePreloader)?_c('div',{staticClass:"spinner-wrapper",class:{'active': _vm.isVisblePreloader}},[_c('b-spinner',{key:"primarySpinner",attrs:{"variant":"primary"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }